
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 6h-3A1.5 1.5 0 010 4.5v-3A1.5 1.5 0 011.5 0h3A1.5 1.5 0 016 1.5v3A1.5 1.5 0 014.5 6zm-3-5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zm21 5h-3A1.5 1.5 0 0118 4.5v-3A1.5 1.5 0 0119.5 0h3A1.5 1.5 0 0124 1.5v3A1.5 1.5 0 0122.5 6zm-3-5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zm-15 23h-3A1.5 1.5 0 010 22.5v-3A1.5 1.5 0 011.5 18h3A1.5 1.5 0 016 19.5v3A1.5 1.5 0 014.5 24zm-3-5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zm21 5h-3a1.5 1.5 0 01-1.5-1.5v-3a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5zm-3-5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z"}}),_c('path',{attrs:{"d":"M18.5 3.5h-13a.5.5 0 010-1h13a.5.5 0 010 1zm0 18h-13a.5.5 0 010-1h13a.5.5 0 010 1zM3 19a.5.5 0 01-.5-.5v-13a.5.5 0 011 0v13a.5.5 0 01-.5.5zm18 0a.5.5 0 01-.5-.5v-13a.5.5 0 011 0v13a.5.5 0 01-.5.5z"}})])
          )
        }
      }
    